import styled from 'styled-components';
import Icon from '../../../../icon';
/**
 * Navigation action sheet link icon container
 */
export const NavigationActionSheetLinkIconContainer = styled(Icon) ``;
